<template>
  <div class="live-list">
    <swipeComponents></swipeComponents>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      v-if="liveList.length > 0"
    >
      <template v-for="(item, index) in liveList">
        <div
          class="live-item"
          :key="index"
          v-if="liveState(item) == 0"
          @click="goLive(item)"
        >
          <div class="live-title">{{ item.title }}</div>
          <div class="live-speaker">
            <span class="speaker">主讲人：{{ item.speaker }}</span>
            <span class="live-state living">
              <van-icon name="live" />直播中
            </span>
          </div>
          <div class="live-content">
            {{ item.content }}
          </div>
        </div>
        <div
          class="live-item"
          :key="index"
          v-if="liveState(item) == 1"
          @click="goLive(item)"
        >
          <div class="live-title">{{ item.title }}</div>
          <div class="live-speaker">
            <span class="speaker">主讲人：{{ item.speaker }}</span>
            <span class="live-state waiting">
              <van-icon name="clock" />未开始
            </span>
          </div>
          <div class="live-content">
            {{ item.content }}
          </div>
        </div>
        <div
          class="live-item"
          :key="index"
          v-if="liveState(item) == 2"
          @click="goLive(item)"
        >
          <div class="live-title">{{ item.title }}</div>
          <div class="live-speaker">
            <span class="speaker">主讲人：{{ item.speaker }}</span>
            <span class="live-state over">
              <van-icon name="eye" />查看视频
            </span>
          </div>
          <div class="live-content">
            {{ item.content }}
          </div>
        </div>
        <!-- <van-field
          v-if="liveState(item) == 2"
          :key="index"
          class="over"
          label="回看"
          :value="item.title"
          :readonly="true"
          :border="false"
          left-icon="play-circle"
          :label-width="labelWidth"
          label-class="left-label"
          @click="goLive(item)"
        /> -->
        <!-- <van-field
          v-if="liveState(item) == 0"
          :key="index"
          class="living"
          label="直播中"
          :value="item.title"
          :readonly="true"
          :border="false"
          left-icon="live"
          :label-width="labelWidth"
          label-class="left-label"
          @click="goLive(item)"
        /> -->
        <!-- <van-field
          v-if="liveState(item) == 1"
          :key="index"
          class="waiting"
          label="未开始"
          :value="item.title"
          :readonly="true"
          :border="false"
          left-icon="clock"
          :label-width="labelWidth"
          label-class="left-label"
          @click="goLive(item)"
        /> -->
      </template>
    </van-list>
    <noticeBox></noticeBox>
    <van-dialog
      v-model="show"
      title="播放视频"
      style="width: 100%;"
      @confirm="onConfirm"
    >
      <video :src="videoUrl" controls style="height: 100%;width: 100%;"></video>
    </van-dialog>
  </div>
</template>

<script>
import { List, Field, Icon } from "vant";
import { getLiveList, addCheckRecord, getApplyInfo } from "@/api";
import swipeComponents from "@/components/swipe.vue";
import noticeBox from "@/components/Notice.vue";
import { Dialog } from "vant";
export default {
  name: "liveList",
  components: {
    [List.name]: List,
    [Icon.name]: Icon,
    [Field.name]: Field,
    noticeBox,
    swipeComponents,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      loading: false,
      finished: false,
      labelWidth: "60",
      pageNo: 1,
      liveList: [],
      show: false,
      videoUrl: ""
    };
  },
  methods: {
    onLoad() {
      this.goGetLiveList();
    },
    onConfirm() {
      this.show = false;
      this.videoUrl = "";
    },
    goLive(obj) {
      if (this.liveState(obj) == 0) {
        // console.log("直播中");
        this.goAddCheckRecord(obj);
        this.$router.push({ path: "livepage" });
      } else if (this.liveState(obj) == 1) {
        // console.log("未开始");
        this.$toast("直播还未开始");
      } else {
        // console.log("已结束");
        this.goAddCheckRecord(obj);
        if (obj.backUrl) {
          // window.location.href = obj.backUrl;
          this.show = true;
          this.videoUrl = obj.backUrl;
        } else {
          this.$toast("视频处理中，请稍后");
        }
      }
    },
    goAddCheckRecord(obj) {
      // console.log(localStorage.getItem("token"));
      const params = {
        mediaTaskId: obj.mediaTaskId,
        speaker: obj.speaker,
        title: obj.title,
        content: obj.content,
        backUrl: obj.backUrl,
        startTime: obj.startTime,
        endTime: obj.endTime,
        createTime: obj.createTime,
        modifyTime: obj.modifyTime
      };
      // console.log(params);
      addCheckRecord(params)
        .then(() => {})
        .catch(() => {});
    },
    goGetLiveList() {
      getLiveList({ pageNo: this.pageNo })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            this.liveList = this.liveList.concat(res.data.records);
            this.loading = false;
            if (this.pageNo >= Number(res.data.pages)) {
              this.finished = true;
            } else {
              this.pageNo += 1;
              this.finished = false;
            }
          }
        })
        .catch(() => {
          this.$toast("网络错误");
        });
    },
    liveState(obj) {
      let s = obj.playDate + " " + obj.startTime;
      let e = obj.playDate + " " + obj.endTime;
      let date = new Date();
      let dateS = new Date(s.replace(/-/g, "/"));
      let dateE = new Date(e.replace(/-/g, "/"));
      let currentTime = date.getTime();
      let startTime = dateS.getTime();
      let endTime = dateE.getTime();
      let inTime = startTime <= currentTime && currentTime <= endTime;
      if (currentTime < startTime) {
        return 1;
      } else if (inTime) {
        return 0;
      } else {
        return 2;
      }
    },
    goGetApplyInfo() {
      getApplyInfo()
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            if (!res.data.applyUserName) {
              this.$toast("请先报名");
              this.$router.push({ path: "/sign" });
            }
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.goGetLiveList();
    this.goGetApplyInfo();
  }
};
</script>

<style lang="stylus">
.live-list
  .van-list
    .van-cell
      background-color #fff
      .van-field__left-icon
        margin-right 20px
    .living
      color #1989fa
      .van-field__control
        color #1989fa
        text-overflow ellipsis
        white-space nowrap
        overflow hiddle
    .waiting
      color #999999
      .van-field__control
        color #999999
        text-overflow ellipsis
        white-space nowrap
        overflow hiddle
    .over
      color #07c160
      .van-field__control
        color #07c160
        text-overflow ellipsis
        white-space nowrap
        overflow hiddle
    .live-item
      padding 15px
      border-bottom 1px solid #f6f6f6
      background-color #fff
      .live-title
        font-size 14px
        color #333333
        text-overflow ellipsis
        overflow hidden
        white-space nowrap
      .live-speaker
        font-size 12px
        color #333333
        line-height 18px
        margin-top 10px
        display flex
        span.speaker
          display block
          font-size 12px
        span.live-state
          display block
          font-size 12px
          margin-left 20px
          position relative
          padding-left 18px
          .van-icon
            font-size 14px
            position absolute
            left 0
            top 50%
            transform translate(0, -50%)
        span.living
          color #1989fa
        span.waiting
          color #999999
        span.over
          color #07c160
      .live-content
        margin-top 10px
        font-size 12px
        color #999999
</style>
